import React, { useRef } from "react";
import { createPortal } from "react-dom";
import { Close } from "@mui/icons-material";
import backgroundImage from "~/images/modal-background-image.png";
import useOutsideClick from "../../Hooks/useOutsideClick";
import ProfileCard from "../../ProfileCard";
import EntityInfo from "../../Tpas/EntityInfo";

const DeletionModal = ({ registration, setRegistrations, handleSubmit, closeModal }) => {
  const modalRef = useRef();
  useOutsideClick(modalRef, closeModal);

  return createPortal(
    <div className="tpa-modal__background">
      <div className="tpa-modal__container" ref={modalRef}>
        <div className="tpa-modal__header">
          <div className="tpa-modal__header__img">
            <img src={backgroundImage} width={145} />
          </div>
          <div className="button button--sq-md button--transparent" onClick={closeModal}>
            <Close />
          </div>
        </div>
        <div className="tpa-modal__body">
          <div className="flex flex-column gap--16">
            <div className="t--xl t--500">Rescind Entity Enrollment</div>
            <ProfileCard
              initials={registration.entity_name[0]}
              title={registration.entity_name}
              subtitle={registration.id_340b}
            />
            <div className="t--subtitle">
              By clicking Confirm, the 340B ESP enrollment for{" "}
              <span className="t--500 t--md">
                {registration.entity_name} – {registration.id_340b}
              </span>{" "}
              will be rescinded. This means if you wish to enroll this entity, you will have to
              begin the enrollment process again.
            </div>
          </div>
          <div className="flex justify-content-end gap--16">
            <button className="button button--white t--500" onClick={closeModal}>
              Cancel
            </button>
            <button
              className="button button--blue t--500"
              onClick={(e) => handleSubmit(e, registration)}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DeletionModal;
